module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-07-a0c1113d1d236197077c073186ac4c60.jpg";